import { inject, Injectable } from "@angular/core"
import { ApiBaseService } from "@app/core/services/api-base.service"
import { Observable } from "rxjs"
import { InventoryBalance } from "../models/inventory-balance.model"

@Injectable({
    providedIn: 'root'
})
export class InventoryApiService {

    readonly #API_PATH_INVENTORY: string = 'inventory'
    readonly #apiBaseService = inject(ApiBaseService)

    getInventoryBalances(): Observable<InventoryBalance[]> {
        return this.#apiBaseService.observablePost<InventoryBalance[]>(`${this.#API_PATH_INVENTORY}/GetInventoryBalances`, {})
    }
}
